import usePaymentData from '../../hooks/usePaymentData';
import ManagerPaymentSummarizeTable from './components/managerPaymentSummarizeTable/ManagerPaymentSummarizeTable';
import PaymentSummarizeTable from './components/paymentSummarizeTable/PaymentSummarizeTable';
import PreManagerResultFinalTable from './components/preManagerResultFinalTable/PreManagerResultFinalTable';
import PreManagerResultTable from './components/preManagerResultTable/PreManagerResultTable';
import PreResultTable from './components/preResultTable/PreResultTable';
import { PaymentWrapper, Title } from './PaymentData.styled';

const PaymentData = ({
	consultantResults,
	paymentData,
	forexRates,
	reloadData,
}) => {
	const hook = usePaymentData();

	return (
		<PaymentWrapper>
			<Title>
				Results for:{' '}
				{
					hook.consultants?.find((c) => c.value === consultantResults._id)
						?.label
				}
			</Title>
			{consultantResults.data.map((payment, idx) => (
				<PreResultTable
					key={idx}
					payment={payment}
					consultantResults={consultantResults}
					reloadData={reloadData}
				/>
			))}
			{consultantResults && (
				<PaymentSummarizeTable
					paymentData={paymentData}
					consultantResults={consultantResults}
				/>
			)}
			{!!consultantResults?.data?.filter((d) => d.team?.length && !d.is_final)
				?.length && (
				<PreManagerResultTable consultantResults={consultantResults} />
			)}
			{!!consultantResults?.data?.filter((d) => d.team?.length && d.is_final)
				?.length && (
				<PreManagerResultFinalTable consultantResults={consultantResults} />
			)}
			{!!consultantResults?.data?.filter((d) => d.team?.length)?.length && (
				<ManagerPaymentSummarizeTable
					consultantResults={consultantResults}
					forexRates={forexRates}
				/>
			)}
		</PaymentWrapper>
	);
};

export default PaymentData;
